import { Box, Title } from '@mantine/core';
import { AppForm } from '../components/AppForm';

export const AddApp = () => {
  return (
    <Box>
      <Title order={3} mb={12}>
        Add new application configuration
      </Title>
      <AppForm app={null} />
    </Box>
  );
};
